import $ from 'jquery';

$(function() {

    initFeaturedSupplierCarousel();

});


function initFeaturedSupplierCarousel() {

    $('.featured-supplier-wrapper .arrow').on('click', function() {

        console.log('feature arrow click');

        let $slides = $(this).closest('.content-wrapper').find('.featured-supplier-slider');
        let slideCount = $slides.find('.slide').length;
        let currentId = parseInt($slides.find('.current').attr('data-id'));

        // Set the new current slide id
        if ($(this).hasClass('arrow-right')) {
            currentId = modifyId(currentId, 1, slideCount);
        } else {
            currentId = modifyId(currentId, -1, slideCount);
        }

        $slides.find('.slide').removeClass('next-1 next-2 current');

        $slides.find('.slide[data-id=' + currentId + ']').addClass('current');
        if (slideCount > 1) {
            $slides.find('.slide[data-id=' + modifyId(currentId, 1, slideCount) + ']').addClass('next-1');
        }
        if (slideCount > 2) {
            $slides.find('.slide[data-id=' + modifyId(currentId, 2, slideCount) + ']').addClass('next-2');
        }

    });

}


function modifyId(id, delta, slideCount) {

    let modifiedId = id;
    if (delta < 0) {
        modifiedId = (id + delta);
        if (modifiedId < 0) { (modifiedId += slideCount); }
    } else {
        modifiedId = (id + delta);
        if (modifiedId >= slideCount) { (modifiedId -= slideCount); }
    }

    return modifiedId;

}
